import { Container, Draggable } from 'react-smooth-dnd';
import React, { useState } from 'react';

import SortablePracticeStackItem from '../components/sortable-stack-item';

//import Message from 'react-bulma-components/lib/components/message';

const SortablePracticeStack = ({ practices, statePrefix, handleChange, handleDeletePractice, onDrop, skipInstrumentTransponation }) => {

  return (
    <Container lockAxis="y" onDrop={onDrop} dragHandleSelector=".column-drag-handle">
      {practices && practices.map((item, index) => (
        <SortablePracticeStackItem key={index} item={item} index={index} statePrefix={statePrefix} handleChange={handleChange} handleDeletePractice={handleDeletePractice} skipInstrumentTransponation={skipInstrumentTransponation}/>
      ))}
    </Container>
  )
};

export default SortablePracticeStack;